import { Link, NavLink } from "react-router-dom";
import logoDark from "assets/full_logo_horizontal_dark.png";
import logo from "assets/full_logo_horizontal_light.png";
import { DarkThemeToggle, Navbar, useTheme } from "flowbite-react";
import CTA from "./CTA";

export const NAV_HEIGHT = 144;
export const NAV_HEIGHT_MD = 64;

type NavItemsType = {
	title: string;
	link: string;
};

const Navigation = () => {
	const navItems: NavItemsType[] = [
		{ link: "/create-a-will", title: "Create a Will" },
		{ link: "/partners", title: "Partners" },
	];

	const { mode } = useTheme();
	return (
		<Navbar
			// fluid
			className={`h-[${NAV_HEIGHT_MD}px] md:h-[${NAV_HEIGHT}px] sticky top-0 z-50 flex gap-2 w-screen justify-between flex-wrap`}
		>
			<Link to="/">
				<Navbar.Brand className="w-auto mb-1">
					<img
						className="h-10 md:h-16 w-auto"
						src={mode === "dark" ? logoDark : logo}
						alt="logo"
					/>
				</Navbar.Brand>
			</Link>
			<div className="max-md:flex md:order-2 gap-2 hidden">
				{/* <DarkThemeToggle className="hidden sm:block" /> */}
				<div className="hidden xs:block">
					<CTA title="Get started" />
				</div>
				<Navbar.Toggle className="bg-white" />
			</div>
			<Navbar.Collapse className="[&>ul]:mb-0 [&>ul]:items-center [&>ul]:max-md:items-start">
				{navItems.map((items) => (
					<NavLink
						className={({ isActive }) =>
							[
								"uppercase",
								isActive
									? "text-primary dark:text-secondary"
									: "dark:text-white text-darkblue hover:text-primary hover:dark:text-secondary",
							]
								.filter(Boolean)
								.join(" ")
						}
						key={items.link}
						to={items.link}
					>
						{items.title}
					</NavLink>
				))}
				<div className="flex max-md:hidden">
					<CTA title="Get started" />
				</div>
			</Navbar.Collapse>
		</Navbar>
	);
};

export default Navigation;
